// import React from 'react'
import { Select, Image, Box, useToast } from '@chakra-ui/react'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { BiCopy } from 'react-icons/bi';
import intl from '../../utils/intl';

import {
  FacebookShareButton,
  FacebookIcon,
	TelegramShareButton,
  TelegramIcon,
	TwitterShareButton,
  TwitterIcon,
	WeiboShareButton,
  WeiboIcon,
	EmailShareButton,
  EmailIcon,
} from 'next-share';

export const ShareBar = (props) => {
	const toast = useToast();
	return (
		<Box
		 display="flex"
		 onClick={() => props.onDone()}
		>
			<TwitterShareButton url={props.url}>
				<TwitterIcon size={26} round />
			</TwitterShareButton>

			<FacebookShareButton url={props.url}>
				<FacebookIcon size={26} round />
			</FacebookShareButton>

			<TelegramShareButton url={props.url}>
				<TelegramIcon size={26} round />
			</TelegramShareButton>

			{/* <WeiboShareButton url={props.url}>
				<WeiboIcon size={26} round />
			</WeiboShareButton> */}

			{/* <EmailShareButton url={props.url} subject={'NUSIC Sharing email'} body="">
				<EmailIcon size={26} round />
			</EmailShareButton> */}

			<CopyToClipboard text={props.url}
				onCopy={() => toast({
					description: intl.get("copied"),
					status: "success",
					duration: 4000,
					isClosable: true		
				})}>
				<div className="copy_button_round">
					<BiCopy className="copy_button"/>
				</div>
			</CopyToClipboard>
		</Box>
	)
}